import "@fontsource/great-vibes";
import ScrollToTopButton from "components/fixedPlugin/ScrollToTopButton";
import { ResponderGuard } from "components/guards/ResponderGuard";
import AuthLayout from "layouts/auth";
import MainLayout from "layouts/main";
import AssessmentLayout from "layouts/responder";
import { useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useAppSelector } from "reduxFiles/hooks";
import { authLoader } from "services/authLoader";
import { UserRole } from "types/userTypes";
import PaymentStatusModal from "views/company/licenses/PaymentStatusModal";
import AboutPage from "views/shared/AboutPage";
import ContactPage from "views/shared/ContactPage";
import NotFound from "views/shared/NotFound";
import PaymentCallbackPage from "views/shared/PaymentCallbackPage";

const App = () => {
  const { initialized, user } = useAppSelector((state) => state.auth);

  useEffect(() => {
    authLoader();
  }, []);

  if (!initialized) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="loader w-8 text-blue-700" />
      </div>
    );
  }

  return (
    <>
      <ScrollToTopButton />
      <PaymentStatusModal />
      <Routes>
        <Route path="auth/*" element={<AuthLayout />} />

        <Route path="admin/*" element={<MainLayout path="admin" />} />

        <Route path="company/*" element={<MainLayout path="company" />} />

        <Route
          path="organization/*"
          element={<MainLayout path="organization" />}
        />

        <Route
          path="assessment/*"
          element={
            <ResponderGuard>
              <AssessmentLayout />
            </ResponderGuard>
          }
        />

        <Route path="payment/callback" element={<PaymentCallbackPage />} />

        <Route path="about" element={<AboutPage />} />

        <Route path="contact" element={<ContactPage />} />

        <Route
          path="/"
          element={
            <Navigate
              to={
                user?.role === UserRole.ADMIN
                  ? "/admin"
                  : user?.role === UserRole.USER
                  ? user?.organization
                    ? "/organization"
                    : "/company"
                  : "/auth/sign-in"
              }
              replace
            />
          }
        />

        <Route path="/404" element={<NotFound />} />

        <Route path="*" element={<Navigate to="/404" replace />} />
      </Routes>
    </>
  );
};

export default App;
